import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IBankCostLookupListTableRow } from '../../../../../interfaces/lookup/bankCost';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchBankCostOptions } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const BankCostLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { bankCostOptions } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IBankCostLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/admin/lookup-lists/bankcost/${record.id}`)} />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (bankCostOptions.model.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/bankcost', { replace: true });
        }
    }, [bankCostOptions.model.updateStatus]);

    useEffect(() => {
        dispatch(fetchBankCostOptions());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (bankCostOptions.model.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [bankCostOptions.model.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage bank costs lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Bank costs',
                        path: '/admin/lookup-lists/bankcost',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/bankcost/add')}>
                        Add new option
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={bankCostOptions.model.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={bankCostOptions.model.data.map((option, i) => {
                        return { ...option, key: i } as IBankCostLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 50,
                    }}
                />
            </div>
        </div>
    );
};
